import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getToken } from "../configRoutes/api_helper";

let echoInstance = null;
let echoToken = null;

const getBroadcastAuthEndpoint = () => {
  const configuredBaseUrl = process.env.REACT_APP_BACKEND_API_URL_BASE || process.env.REACT_APP_BACKEND_API_URL || "";
  const baseUrl = configuredBaseUrl.replace(/\/+$/, "").replace(/\/api$/, "");

  return `${baseUrl}/broadcasting/auth`;
};

export const getEchoInstance = () => {
  const token = getToken();

  if (echoInstance && echoToken === token) return echoInstance;

  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }

  echoToken = token;

  window.Pusher = Pusher;

  const authEndpoint = getBroadcastAuthEndpoint();

  console.info('[Operator location] Creating Echo instance', {
    hasToken: Boolean(token),
    authEndpoint,
    keyConfigured: Boolean(process.env.REACT_APP_PUSHER_APP_KEY),
    clusterConfigured: Boolean(process.env.REACT_APP_PUSHER_APP_CLUSTER),
  });

  echoInstance = new Echo({
    broadcaster: "pusher",
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    forceTLS: false,
    encrypted: true,
    enabledTransports: ["ws", "wss"],
    authEndpoint,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  echoInstance.connector?.pusher?.connection?.bind('error', (error) => {
    console.warn('[Operator location] Pusher connection error', error);
  });

  echoInstance.connector?.pusher?.connection?.bind('connected', () => {
    console.info('[Operator location] Pusher connected');
  });

  return echoInstance;
};

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
    echoToken = null;
  }
};
